export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/journals`,
        name: `${prefix}.journals.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.journals.index`,
                PageDescription: "Supplier Module: Journals",
            },
        },
    },
    {
        path: `/${prefix}/journals/create`,
        name: `${prefix}.journals.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.journals.index`,
                PageDescription: "Supplier Module: Journals",
            },
        },
    },
];